import { FillImage } from "components/images";
import { CenteredQuote } from "components/quotes";
import { type QuoteProps } from "components/quotes/types";
import React from "react";
import { MediaAccordion } from "ui/accordion";
import { SolidPlate } from "ui/plates";
import { TextTitle } from "ui/text";
import accordion1 from "../../../../public/assets/solutions/advertising/conversion-accordion-1.png";
import accordion2 from "../../../../public/assets/solutions/advertising/conversion-accordion-2.png";
import accordion3 from "../../../../public/assets/solutions/advertising/conversion-accordion-3.png";

export function ReachAndConversionFeatures({ quote }: { quote: QuoteProps }) {
  return (
    <SolidPlate theme="dark" bgColor="new.blue.950" spotlightColor="new.blue.900">
      <TextTitle
        theme="dark"
        size="xl"
        align="center"
        title={
          <>
            Bigger audiences.
            <br />
            Better conversions.
            <br />
            Stronger performance.
          </>
        }
        description="Reach and convert high-value customers across your advertising ecosystem with an high quality identity solution that you can activate in a few clicks."
        maxW="750px"
        mb={{ base: "big", md: "huge" }}
      />

      <MediaAccordion
        theme="dark"
        variant="dynamic"
        direction="right"
        items={[
          {
            title: "Increase audience reach and suppression performance",
            content:
              "Improve audience sizes by enhancing your data with our identity graph. Convert more with higher reach and waste less with better suppression.",
            media: (
              <FillImage
                src={accordion1}
                alt='An abstract illustration that shows a bright green toggle for "Enable Match Booster" turned on, with a description below reading "Increase the match rate with boosted data from Hightouch&apos;s data partners.'
              />
            ),
          },
          {
            title: "Maximize conversion performance",
            content:
              "Conversion signals are the real-time fuel for the ad platforms’ AI systems. Better signals improve budget allocation, bids, and targeting resulting in higher ROAS.",
            media: (
              <FillImage
                src={accordion2}
                alt='An abstract illustration showing a generic e-commerce platform with the "Buy" option selected for a pair of shoes. It then shows the Hightouch logo as a center point that is connecting the e-commerce page to the logos of Meta, Google Ads, and TikTok.'
              />
            ),
          },
          {
            title: "Reach anonymous visitors, business users, and more",
            content:
              "Connect anonymous visits to known profiles, match business and personal identities, and expand your reach into entire households.",
            media: (
              <FillImage
                src={accordion3}
                alt='An abstract illustration showing a "Household ID" that is connected to two separate users and one smart TV.'
              />
            ),
          },
        ]}
      />

      <CenteredQuote
        theme="dark"
        {...quote}
        mt={{ base: "biggest", md: "huger", xl: "hugest" }}
        mb={{ base: 0, md: "bigger", xl: "biggest" }}
      />
    </SolidPlate>
  );
}
